import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customTimeFormat',
})
export class CustomTimeFormatPipe implements PipeTransform {
  transform(value: string): string {
    const [datePart, timePart] = value.split(', ');
    const [day, month, year] = datePart.split('/');
    const [hours, minutes, seconds] = timePart.split(':');
    const processedDate = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);

    const options: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    return new Intl.DateTimeFormat('en-US', options).format(processedDate);
  }
}
